/* global $, Util, alertInterface */
import { addToWishlist, removeFromWishlist, setFavorites } from "@api/utils_2020";
import('./pb-productsdetails-v2.css');

const pbProducsDetailsV2 = {
    wishListService: null,

    initService: () => {
        Util.service("WSPortobelloSite", true, {
            exceptionHandler: alertInterface.showError,
            reflectSuccess: function(service) {
                pbProducsDetailsV2.wishListService = service;
                pbProducsDetailsV2.init();
            },
            reflectError: function() {
                console.error("Erro de conexão, verifique sua conexão com a internet.");
            },
        });  
    },

    init: function() {
        /*
        $(".more .jsFavorite").on("click", function(evt) {
            evt.preventDefault();
            const code = item.data("code");
            if (userLogged)
            {
                const item = $(this);
                
                const suffix = item.data("suffix");
                const isChecked = item.hasClass("favorite-true");

                if (!isChecked) {
                    addToWishlist({
                        code,
                        suffix,
                        service: pbProducsDetailsV2.wishListService,
                        type: "products",
                    });

                    $(this).addClass("favorite-true");
                    $("img.favorite-false", this).hide();
                    $("img.favorite-true", this).show();
                } else {
                    removeFromWishlist({
                        code,
                        suffix,
                        type: "products",
                    });

                    $(this).removeClass("favorite-true");
                    $("img.favorite-true", this).hide();
                    $("img.favorite-false", this).show();
                }
            } else {
                const link = $(this).attr('href');
                // não logado
                initVideoListener();
                showModalLogin(link);
                Util.setCookie('wishlistAdd',code+'|products');
            }     
        });

        setFavorites("products");
        */

        $('.pb-productsdetails-v2 .monoporosa a[href="#expand"]').on('click',function(){
            $(this).parents('.pb-productsdetails-v2 .monoporosa').addClass('expanded')
            $('.pb-productsdetails-v2 .monoporosa a[href="#close"]').show();
            $('.pb-productsdetails-v2 .monoporosa a[href="#expand"]').hide();
        });

        $('.pb-productsdetails-v2 .monoporosa a[href="#close"').on('click',function(){
            $(this).parents('.pb-productsdetails-v2 .monoporosa').removeClass('expanded');
            $('.pb-productsdetails-v2 .monoporosa a[href="#expand"]').show();
            $('.pb-productsdetails-v2 .monoporosa a[href="#close"]').hide();
        });
    },
};

// initialize component
window.loadedComponents.push({ component: "pb-productsdetails-v2", init: pbProducsDetailsV2.initService });

export default() => {
    pbProducsDetailsV2.init();
}